const Segment = {
  page(name, options) {
    if (
      window.analytics &&
      process.env.REACT_APP_SEGMENT_IS_LOGGING === 'true'
    ) {
      window.analytics.page(...arguments);
    }
  },
  identify() {
    if (
      window.analytics &&
      process.env.REACT_APP_SEGMENT_IS_LOGGING === 'true'
    ) {
      window.analytics.identify(...arguments);
    }
  },
  track() {
    if (
      window.analytics &&
      process.env.REACT_APP_SEGMENT_IS_LOGGING === 'true'
    ) {
      window.analytics.track(...arguments);
    }
  }
};
export default Segment;



/** WEBPACK FOOTER **
 ** ./src/helpers/segment.js
 **/